module.exports = "/_next/static/images/715c9de73e1d9badfbde62c6acf15cb9-card-lg.png.webp";